export default __webpack_public_path__ + "8999838a139bc896c43e6a9ad5808740.jpg";